import React, { useContext, useEffect, useRef, useState } from 'react';
import HiddenAudioPlayer from './AudioPlayer';
import ChatArea from './ChatArea';
import { API_URL, BOT_1, BOT_2, TOKEN } from "./Constants/constants";
import axios from 'axios';
import { AppContext } from './Context/Context';
import api from './Constants/Refresh';


const ChatComponent = () => {
  const voice_animation = document.getElementById('voice-animation');
  const [messages, setMessages] = useState([]);
  const audioRef = useRef(null);
  const [typing, setTyping] = useState(false);
  const { chatHistory, setChatHistory, chatId, setChatId } = useContext(AppContext)
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const botUrl = localStorage.getItem('BOT')

  const [chatbotSocket, setChatbotSocket] = useState(null);

  useEffect(() => {
    if (!botUrl) return;

    const socket = new WebSocket(botUrl);
    setChatbotSocket(socket);

    socket.onopen = function (event) {
      const mic = document.getElementById("state-icon");
      const messageInput = document.getElementById("chat-input-text");
      messageInput.disabled = false;
      messageInput.placeholder = "matnni shu yerga kiriting...";
      messageInput.style.border = "none";
      mic.style.pointerEvents = "all";
    };

    // cleanup: eski soketni yopib yuborish
    return () => {
      socket.close();
    };
  }, [botUrl]);

  const handleNewChat = () => {
    setChatId(0)
    setMessages([])
  };

  const handleDeleteChat = (id) => {
    setChatHistory(chatHistory.filter((chat) => chat.id !== id));
  };

  const getMessage = (id) => {
    setChatId(id)
    api.get(`${API_URL}/chats/${id}/messages`, {
      headers: {
        Authorization: `Bearer ${TOKEN}`
      },
    }).then((res) => {
      setMessages(res.data)
    }).catch((err) => { })
  }
  // console.log(chatId, "iddddd")  
  return (
    <div className='html'>
      <div className='body'>
        <button className="hamburger" onClick={() => { setSidebarOpen(!sidebarOpen) }}>
          ☰
        </button>

        <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="history-top">
            <h3>Тарих</h3>
            <span onClick={() => setSidebarOpen(!sidebarOpen)} style={{ cursor: 'pointer', fontSize: '18px' }}>✖</span>
          </div>
          <button className="new-chat" onClick={handleNewChat}>
            + New chat
          </button>
          <ul className='chat-list'>
            {chatHistory.map((chat) => (
              <li onClick={() => getMessage(chat.id)} key={chat.chat_id} className="chat-item">
                <span className="chat-title">{chat.title}</span>
                <span className="delete" onClick={(e) =>{ handleDeleteChat(chat.id); e.stopPropagation() }}>✖</span>
              </li>
            ))}
          </ul>
        </div>

        <div className={sidebarOpen ? "chatContainer" : ""}>
          <div className="app">
            <div className="wrapper">
              <HiddenAudioPlayer src={""} audioRef={audioRef} />
              <ChatArea
                typing={typing}
                setTyping={setTyping}
                messages={messages}
                setMessages={setMessages}
                chatbotSocket={chatbotSocket}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatComponent;
